import { themePrimary } from 'shared/utils/cssUtility';
import { SvgIconType } from './svg.interface';

const MessageChatIcon: SvgIconType = ({
  width = 20,
  height = 19,
  className = '',
  color = themePrimary
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 0C17.0609 0 18.0783 0.421437 18.8284 1.1716C19.5786 1.92176 20 2.9392 20 4.00009V12.0003C20 13.0612 19.5786 14.0786 18.8284 14.8288C18.0783 15.5789 17.0609 16.0004 16 16.0004H11.276L6.514 18.8574C6.37059 18.9435 6.20788 18.9922 6.04077 18.9991C5.87366 19.0061 5.70749 18.971 5.55746 18.897C5.40743 18.8231 5.27833 18.7127 5.18199 18.576C5.08565 18.4393 5.02514 18.2806 5.006 18.1144L5 18.0004V16.0004H4C2.97376 16.0004 1.98677 15.6059 1.24319 14.8986C0.499605 14.1913 0.0563122 13.2253 0.00500011 12.2003L0 12.0003V4.00009C0 2.9392 0.421427 1.92176 1.17157 1.1716C1.92172 0.421437 2.93913 0 4 0H16ZM12 9.00021H6C5.73478 9.00021 5.48043 9.10557 5.29289 9.29311C5.10536 9.48065 5 9.73501 5 10.0002C5 10.2655 5.10536 10.5198 5.29289 10.7074C5.48043 10.8949 5.73478 11.0003 6 11.0003H12C12.2652 11.0003 12.5196 10.8949 12.7071 10.7074C12.8946 10.5198 13 10.2655 13 10.0002C13 9.73501 12.8946 9.48065 12.7071 9.29311C12.5196 9.10557 12.2652 9.00021 12 9.00021ZM14 5.00012H6C5.73478 5.00012 5.48043 5.10548 5.29289 5.29302C5.10536 5.48056 5 5.73492 5 6.00014C5 6.26536 5.10536 6.51972 5.29289 6.70726C5.48043 6.89481 5.73478 7.00016 6 7.00016H14C14.2652 7.00016 14.5196 6.89481 14.7071 6.70726C14.8946 6.51972 15 6.26536 15 6.00014C15 5.73492 14.8946 5.48056 14.7071 5.29302C14.5196 5.10548 14.2652 5.00012 14 5.00012Z"
      fill={color}
    />
  </svg>
);

export default MessageChatIcon;
